module.exports = __webpack_public_path__ + "cc86515fde3db39833d5915b5d49ae81.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/modelo3.png
// module id = 2814
// module chunks = 1